import type {
  ContractResponse,
  PropertyFileResponse,
  PropertyFileTreeNode,
  SupplierInvoiceResponse,
} from '@/shared/api';
import { AkteEditModals } from './AkteEditModals';
import { AkteMutationDialogs } from './AkteMutationDialogs';
import { AkteUploadModals } from './AkteUploadModals';
import type { useAkteDialogs } from './useAkteDialogs';
import type { useAkteMutations } from './useAkteMutations';
import type { useAkteUploads } from './useAkteUploads';

interface EditState {
  previewFile: PropertyFileResponse | null;
  editFile: PropertyFileResponse | null;
  editContract: ContractResponse | null;
  editInvoice: SupplierInvoiceResponse | null;
  closePreview: () => void;
  closeEditFile: () => void;
  closeEditContract: () => void;
  closeEditInvoice: () => void;
}

interface Props {
  propertyId: string;
  tree: PropertyFileTreeNode | undefined;
  dialogs: ReturnType<typeof useAkteDialogs>;
  mutations: ReturnType<typeof useAkteMutations>;
  uploads: ReturnType<typeof useAkteUploads>;
  edit: EditState;
  onDownload: (f: PropertyFileResponse) => void;
}

/** Bündelt alle Overlay-Hosts der Akte: Mutations-Dialoge, Upload-Modals, Preview/Edit-Modals. */
export function AkteDialogHost({
  propertyId,
  tree,
  dialogs,
  mutations,
  uploads,
  edit,
  onDownload,
}: Props) {
  return (
    <>
      {tree && <AkteMutationDialogs tree={tree} dialogs={dialogs} mutations={mutations} />}
      <AkteUploadModals uploads={uploads} />
      <AkteEditModals
        propertyId={propertyId}
        previewFile={edit.previewFile}
        editFile={edit.editFile}
        editContract={edit.editContract}
        editInvoice={edit.editInvoice}
        onClosePreview={edit.closePreview}
        onCloseEditFile={edit.closeEditFile}
        onCloseEditContract={edit.closeEditContract}
        onCloseEditInvoice={edit.closeEditInvoice}
        onDownload={onDownload}
      />
    </>
  );
}
